export default "__VITE_ASSET__BkXDLRKU__"